import PropTypes from 'prop-types';
import React from 'react';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_FORM,
  DOC_TYPE_ID_CHECK,
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  DOC_TYPE_INFORMATION,
  DOC_TYPE_PAYMENT,
  DOC_TYPE_PDF_FORM
} from './utils';
import { Icon } from 'framework7-react';

const iconColor = '#444';
const iconContainer = {
  marginTop: 2,
  border: '2px solid rgba(100,100,100,0.3)',
  borderRadius: 5,
  backgroundColor: 'rgba(100, 110, 100, 0.05)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const iconBadge = (text, iconSize, color) => {
  let size = iconSize / 1.5 + 4;
  return (
    <span
      style={{
        borderRadius: '50%',
        background: color,
        color: '#fff',
        width: size,
        height: size,
        fontSize: size - size / 10,
        marginLeft: -size / 1.5,
        marginTop: -size / 1.5,
        position: 'absolute',
        textAlign: 'center',
        fontWeight: 'bold',
        lineHeight: size - 4 + 'px',
        border: '2px solid #fff'
      }}
    >
      {text}
    </span>
  );
};

const CommonIcon = props => {
  const { color, outerSize, children, badgeText, ...rest } = props;
  return (
    <div
      style={{
        ...iconContainer,
        borderColor: color,
        width: outerSize,
        height: outerSize
      }}
      {...rest}
    >
      {children}
      {badgeText && iconBadge(badgeText, outerSize, color)}
    </div>
  );
};

CommonIcon.propTypes = {
  badgeText: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string.isRequired,
  outerSize: PropTypes.number.isRequired
};

export const typeDocumentIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="-2 -2 36 36">
      <g>
        <path
          fill={iconColor}
          d="M22.414,0H4v32h24V5.584L22.414,0z M21.998,2.413L25.586,6h-3.588
			C21.998,6,21.998,2.413,21.998,2.413z M26,30H6V1.998h14v6.001h6V30z"
        />
        <path
          fill={iconColor}
          d="M18,12h-4l-2,2h-2c0,0-2,0-2,2v6c0,2,2,2,2,2s10.641,0,12,0c2,0,2-2,2-2s0-4,0-6s-2-2-2-2h-2L18,12
			z M16,22c-1.658,0-3-1.342-3-3c0-1.656,1.342-3,3-3c1.655,0,3,1.344,3,3C19,20.658,17.655,22,16,22z"
        />
      </g>
    </svg>
  </CommonIcon>
);

export const typeSignatureIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="0 0 24 24">
      <path
        fill={iconColor}
        d="M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z"
      />
    </svg>
  </CommonIcon>
);

export const typeInformationIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="0 0 24 24">
      <path
        fill={iconColor}
        d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
      />
    </svg>
  </CommonIcon>
);

export const typeImmediateConfirmationIcon = (
  innerSize,
  outerSize,
  badgeText
) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <Icon md="material:check" size={innerSize} />
  </CommonIcon>
);

export const typeFormIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="0 0 24 24">
      <path
        fill={iconColor}
        d="M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z"
      />
    </svg>
  </CommonIcon>
);

export const typeFormPdfIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg
      viewBox="0 0 24 24"
      style={{ width: innerSize, height: innerSize }}
      id="svg4"
      fill={iconColor}
    >
      <g
        transform="matrix(0.50645205,0,0,0.50645205,11.302396,-54.347774)"
        id="layer1"
      >
        <g
          transform="matrix(1.4843054,0,0,1.4843054,17.471885,-90.243502)"
          id="g899"
        >
          <g id="g876">
            <path
              id="path2697"
              d="m -23.40766,161.09299 c -1.45669,-1.45669 0.11934,-3.45839 4.39648,-5.58397 l 2.69124,-1.33743 1.04845,-2.29399 c 0.57665,-1.26169 1.43729,-3.32036 1.91254,-4.5748 l 0.8641,-2.28082 -0.59546,-1.68793 c -0.73217,-2.07547 -0.99326,-5.19438 -0.52872,-6.31588 0.62923,-1.51909 2.69029,-1.36323 3.50626,0.26515 0.63727,1.27176 0.57212,3.57488 -0.18329,6.47946 l -0.6193,2.38125 0.5455,0.92604 c 0.30003,0.50932 1.1764,1.71867 1.9475,2.68743 l 1.44924,1.80272 1.8033728,-0.23533 c 5.72900399,-0.74758 7.6912472,0.523 7.6912472,2.34476 0,2.29921 -4.4984914,2.48899 -8.2760865,-0.16423 -0.8499666,-0.59698 -1.4336605,-1.19001 -1.4336605,-1.19001 0,0 -2.3665326,0.48178 -3.531704,0.79583 -1.202707,0.32417 -1.80274,0.52719 -3.564509,1.12186 0,0 -0.61814,0.89767 -1.02094,1.55026 -1.49858,2.4279 -3.24833,4.43998 -4.49793,5.1723 -1.3991,0.81993 -2.86584,0.87582 -3.60433,0.13733 z m 2.28605,-0.81668 c 0.81883,-0.50607 2.47616,-2.46625 3.62341,-4.28553 l 0.46449,-0.73658 -2.11497,1.06339 c -3.26655,1.64239 -4.76093,3.19033 -3.98386,4.12664 0.43653,0.52598 0.95874,0.48237 2.01093,-0.16792 z m 21.21809,-5.95578 c 0.80089,-0.56097 0.68463,-1.69142 -0.22082,-2.1472 -0.70466,-0.35471 -1.2726074,-0.42759 -3.1031574,-0.40057 -1.1249,0.0767 -2.9337647,0.3034 -3.2403347,0.37237 0,0 0.993716,0.68678 1.434896,0.93922 0.58731,0.33544 2.0145161,0.95811 3.0565161,1.27706 1.02785,0.31461 1.6224,0.28144 2.0729,-0.0409 z m -8.53152,-3.54594 c -0.4847,-0.50952 -1.30889,-1.57296 -1.83152,-2.3632 -0.68353,-0.89643 -1.02629,-1.52887 -1.02629,-1.52887 0,0 -0.4996,1.60694 -0.90948,2.57394 l -1.27876,3.16076 -0.37075,0.71695 c 0,0 1.971043,-0.64627 2.97389,-0.90822 1.0621668,-0.27744 3.21787,-0.70134 3.21787,-0.70134 z m -2.74938,-11.02573 c 0.12363,-1.0375 0.1761,-2.07346 -0.15724,-2.59587 -0.9246,-1.01077 -2.04057,-0.16787 -1.85154,2.23517 0.0636,0.8084 0.26443,2.19033 0.53292,3.04209 l 0.48817,1.54863 0.34358,-1.16638 c 0.18897,-0.64151 0.47882,-2.02015 0.64411,-3.06364 z"
            />
            <g id="g858" />
          </g>
        </g>
      </g>
    </svg>
  </CommonIcon>
);

export const typePaymentIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="0 0 24 24">
      <path
        fill={iconColor}
        d="M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
      />
    </svg>
  </CommonIcon>
);

export const typeIdCheckIcon = (innerSize, outerSize, badgeText) => (
  <CommonIcon color={iconColor} outerSize={outerSize} badgeText={badgeText}>
    <svg style={{ width: innerSize, height: innerSize }} viewBox="-2 -2 27 27">
      <path
        fill={iconColor}
        d="M22,3H2C0.91,3.04 0.04,3.91 0,5V19C0.04,20.09 0.91,20.96 2,21H22C23.09,20.96 23.96,20.09 24,19V5C23.96,3.91 23.09,3.04 22,3M22,19H2V5H22V19M14,17V15.75C14,14.09 10.66,13.25 9,13.25C7.34,13.25 4,14.09 4,15.75V17H14M9,7A2.5,2.5 0 0,0 6.5,9.5A2.5,2.5 0 0,0 9,12A2.5,2.5 0 0,0 11.5,9.5A2.5,2.5 0 0,0 9,7M14,7V8H20V7H14M14,9V10H20V9H14M14,11V12H18V11H14"
      />
    </svg>
  </CommonIcon>
);
export const getDocumentTypeIcon = (
  type,
  innerSize = 25,
  outerSize = 30,
  badgeText
) => {
  switch (type) {
    case DOC_TYPE_DOCUMENT:
      return typeDocumentIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_INFORMATION:
      return typeInformationIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_IMMEDIATE_CONFIRMATION:
      return typeImmediateConfirmationIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_FORM:
      return typeFormIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_PDF_FORM:
      return typeFormPdfIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_PAYMENT:
      return typePaymentIcon(innerSize, outerSize, badgeText);
    case DOC_TYPE_ID_CHECK:
      return typeIdCheckIcon(innerSize, outerSize, badgeText);
    default:
      return <></>;
  }
};
